import React from 'react'
import { Redirect } from 'react-router'
import { ROUTES } from '../enums/routes'
import Confirmation from '../components/Confirmation'
import { isLoggedIn } from '../services/utils'
import NoSidebarTemplate from './templates/NoSidebarTemplate'

const ConfirmationPage = () => {
  document.title = 'Louvre Banque Privée - Confirmation'

  if (!isLoggedIn()) {
    return <Redirect to={ROUTES.welcome} />
  }

  return (
    <NoSidebarTemplate>
      <div className="colMd8 offsetMd2">
        <div className="card textCenter pt5 pb5 px3 px7md">
          <Confirmation />
        </div>
      </div>
    </NoSidebarTemplate>
  )
}

export default ConfirmationPage
